import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useHistory } from 'react-router-dom'
import { Button } from '../../../components/shadcn/Button'
import { useOrderGroupDetailContext } from '../context/OrderGroupDetailContext'
import { Tag } from '../../../components/Tag'
import { graphql, useFragment } from '../../../gql'
import { PROCESS_STATUS_NAME } from '../../../lib/Util'
import { faArrowLeft, faArrowRight, faStop } from '@fortawesome/pro-solid-svg-icons'
import { ProfileDropdown } from '../../../components/ProfileDropdown'

export const Header_OrderGroupFragment = graphql(`
  fragment Header_OrderGroup on OrderGroup {
    id
    name
    user {
      id
      name
    }
    tags {
      id
      name
      color
      ...TagComponent_TagFragment
    }
    orders {
      id
    }
  }
`)

export const Header: React.FC<{
  handleSubmit: () => void
  handleStop: () => void
  isStopping?: boolean
  allOrdersHasSameStatus: boolean
  processStatus: string
  isSubmitting: boolean
}> = ({ handleSubmit, handleStop, isStopping, allOrdersHasSameStatus, processStatus, isSubmitting }) => {
  const history = useHistory()
  const { orderGroup } = useOrderGroupDetailContext()
  const group = useFragment(Header_OrderGroupFragment, orderGroup)

  return (
    <nav className="bg-white border-b border-cool-grey flex justify-between items-center min-h-16 px-3">
      <div className="flex flex-row divide-x divide-cool-grey mr-4 items-center">
        <Button onClick={() => history.push('/groups')} variant="outline" size="sm" className="btn-header mr-6">
          <FontAwesomeIcon icon={faArrowLeft} className="mr-2" />
          Zpět
        </Button>
        <div>
          <div className="font-bold text-xl px-6">Skupina: {group?.name || `#${group?.id}`}</div>
          <div className="text-sm text-primary-blue font-semibold px-6">
            {group?.orders?.length || 0} objednávek – {PROCESS_STATUS_NAME[processStatus as ProcessStates]}
          </div>
        </div>
      </div>
      <div className="flex gap-8 items-center py-2.5">
        <div className="flex items-center gap-3 flex-wrap">
          {(group?.tags || []).map(tag => (
            <div key={tag.id}>
              <Tag tag={tag} />
            </div>
          ))}
        </div>
        {group?.user && <div className="text-sm text-gray-600">Vytvořil: {group.user.name}</div>}
        {isSubmitting ? (
          <Button
            onClick={handleStop}
            variant="destructive"
            size="sm"
            className="btn-header mr-6"
            disabled={isStopping}>
            <FontAwesomeIcon icon={faStop} className="mr-2" />
            {isStopping ? 'Zastavování...' : 'Zastavit'}
          </Button>
        ) : (
          <Button
            onClick={handleSubmit}
            variant="default"
            size="sm"
            className="btn-header mr-6"
            disabled={
              processStatus === 'packed' ||
              processStatus === 'shipped' ||
              processStatus === 'delivered' ||
              processStatus === 'returned' ||
              processStatus === 'cancelled'
            }>
            <FontAwesomeIcon icon={faArrowRight} className="mr-2" />
            {allOrdersHasSameStatus ? 'Odeslat' : 'Pokračovat'}
          </Button>
        )}
        <div className="relative flex items-center">
          <ProfileDropdown />
        </div>
      </div>
    </nav>
  )
}
